import EmployeeRewards from './EmployeeRewards/index'
export default EmployeeRewards
